export const validation = {
  titleMaxChar: 30,
  paragraphMaxChar: 300,
  feature: {
    min: 1,
    max: 3
  }
}
